import { PageHero } from '@/components/common/Sections';
import { IMAGES, COMPANY_INFO } from '@/lib/constants';

export default function PrivacyPage() {
  return (
    <div className="page-transition">
      <PageHero title="Privacy Policy" subtitle="How we collect, use, and protect your personal information" backgroundImage={IMAGES.airport} />

      <section className="section-padding bg-white">
        <div className="container-custom max-w-4xl">
          <div className="space-y-8 text-[#4A5568] leading-relaxed">

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">1. Information We Collect</h2>
              <p className="mb-3">We collect personal information that you voluntarily provide when using our services, including:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Full name, email address, phone number</li>
                <li>Passport details and travel documents (for visa/travel bookings)</li>
                <li>Payment information (processed securely through third-party providers)</li>
                <li>Travel preferences and booking history</li>
                <li>Communication records (emails, form submissions, chat messages)</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">2. How We Use Your Information</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Processing travel bookings, visa applications, and related services</li>
                <li>Communicating with you about your bookings and enquiries</li>
                <li>Sending service updates, travel advisories, and promotional offers (with your consent)</li>
                <li>Improving our services and customer experience</li>
                <li>Complying with legal obligations and regulatory requirements</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">3. Information Sharing</h2>
              <p className="mb-3">We may share your information with:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Airlines, hotels, and travel service providers (to fulfill your bookings)</li>
                <li>Embassies and consulates (for visa processing)</li>
                <li>Insurance companies (for travel insurance claims)</li>
                <li>Payment processors (for secure transaction processing)</li>
                <li>Government authorities (when required by law)</li>
              </ul>
              <p className="mt-3">We do not sell your personal information to third parties for marketing purposes.</p>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">4. Data Security</h2>
              <p>We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.</p>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">5. Cookies & Tracking</h2>
              <p>Our website may use cookies and similar tracking technologies to enhance your browsing experience, analyze site traffic, and understand user preferences. You can manage cookie preferences through your browser settings.</p>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">6. Data Retention</h2>
              <p>We retain your personal data only for as long as necessary to fulfill the purposes for which it was collected, comply with legal obligations, resolve disputes, and enforce our agreements. Travel booking records may be retained for up to 7 years as required by regulatory guidelines.</p>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">7. Your Rights</h2>
              <p className="mb-3">You have the right to:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Access the personal data we hold about you</li>
                <li>Request correction of inaccurate data</li>
                <li>Request deletion of your data (subject to legal retention requirements)</li>
                <li>Opt out of marketing communications at any time</li>
                <li>Withdraw consent for data processing where consent was the basis</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">8. Third-Party Links</h2>
              <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to read the privacy policies of any third-party sites you visit.</p>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">9. Changes to This Policy</h2>
              <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date. We encourage you to review this policy periodically.</p>
            </div>

            <div>
              <h2 className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-4">10. Contact Us</h2>
              <p>If you have questions about this Privacy Policy or wish to exercise your data rights, please contact us at <a href={`mailto:${COMPANY_INFO.email}`} className="text-[#D4AF37] hover:underline">{COMPANY_INFO.email}</a> or call <a href={`tel:${COMPANY_INFO.phone}`} className="text-[#D4AF37] hover:underline">{COMPANY_INFO.phone}</a>.</p>
            </div>

            <p className="text-sm text-[#4A5568]/70 border-t border-slate-200 pt-6">Last updated: March 2026</p>
          </div>
        </div>
      </section>
    </div>
  );
}
